import React, { useState } from 'react';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import { IMenuListItem } from '../../../../../../../../Interfaces/responseTypes';
import SearchMenu from '../../../../../../../../Components/Inputs/SearchInput/SearchMenuItem/searchMenu';
import { MenuSearchResult } from '../../../../../../../../Components/Inputs/SearchInput/SearchMenuItem/searchMenu-hooks';
import styles from './searchDrawer.module.scss';

interface IProps {
    logo: string,
    menu_list: IMenuListItem[],
    searchHandler: (result: MenuSearchResult) => void;
    onCloseDrawer: () => void
};

const useSearchDrawer: React.FC<IProps> = (props) => {
    const { logo, menu_list, searchHandler, onCloseDrawer } = props;
    const { mobileScreen,baseURL } = useNoAuthHooks();
    const [searchResultsExist, setSearchResultsExist] = useState<boolean>(false);

    return (
        <>
            <div className={`
                ${styles.container}
                 ${mobileScreen ? styles.topSide : styles.rightSide}
                 ${(mobileScreen && searchResultsExist) ? styles.expandedBox : ''}
                 `}>
               <div className={styles.logoBox}>
               <img src={`${baseURL}${logo}`} alt='logo.png' className={styles.logo} />
                     </div>
                <div className={styles.itemBox}>
                    <SearchMenu
                        menu_list={menu_list}
                        searchHandler={searchHandler}
                        onClose={onCloseDrawer}
                        containerStyles={mobileScreen ? styles.searchBox : undefined}
                        onResultsChange={setSearchResultsExist}
                    />
                </div>
            </div>
        </>
    )
};

export default useSearchDrawer
